import React from 'react';

import { Challenge } from '@wix/ambassador-challenges-v1-challenge/types';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { getMediaPreview } from '../../../../selectors/media';
import { FCWithChildren } from '@wix/challenges-web-library';
import { getProgramAltImageText } from '../../../../selectors/getProgramImageAltText';
import { ImageResizeOptions, Image } from 'wix-ui-tpa/cssVars';
import { classes, st } from './ChallengeImage.st.css';

export const ChallengeImage: FCWithChildren<{
  challenge: Challenge;
}> = (props) => {
  const { isMobile, isRTL } = useEnvironment();
  const media = props.challenge?.settings?.description?.media;
  const imgUrl = getMediaPreview(media);

  return imgUrl || !isMobile ? (
    <figure
      className={st(classes.root, {
        mobile: isMobile,
        rtl: isRTL,
      })}
    >
      {imgUrl ? (
        <Image
          alt={getProgramAltImageText(props.challenge)}
          className={classes.image}
          src={imgUrl}
          resize={ImageResizeOptions.cover}
        />
      ) : null}
    </figure>
  ) : null;
};
